/* eslint-disable react/require-default-props */
import React, { useRef, useEffect, useCallback } from 'react';
import ReactDOM from 'react-dom';
import useHideUserSupportBtn from '@hooks/useHideUserSupportBtn';
import { BrushawayProvider, useBrushaway } from './BrushawayContext';
import './BrushawayStyles.scss';
const DEFAULT_PANEL_WIDTH = 480;
function BrushawayInternal({ anchor, children, minWidth, closeOnClickOutside = false, drawer, drawerPosition = 'left', className = '' }) {
    const panelWidth = minWidth !== null && minWidth !== void 0 ? minWidth : DEFAULT_PANEL_WIDTH;
    const { isOpen, toggleBrushaway, closeBrushaway } = useBrushaway();
    const brushawayRef = useRef(null);
    useHideUserSupportBtn(isOpen);
    const handleKeyUp = useCallback((event) => {
        if (event.key === 'Escape' && isOpen) {
            closeBrushaway();
        }
    }, [isOpen, closeBrushaway]);
    const handleClickOutside = useCallback((event) => {
        if (!closeOnClickOutside || !isOpen)
            return;
        const target = event.target;
        if (brushawayRef.current && !brushawayRef.current.contains(target)) {
            closeBrushaway();
        }
    }, [closeOnClickOutside, isOpen, closeBrushaway]);
    useEffect(() => {
        window.addEventListener('keyup', handleKeyUp);
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            window.removeEventListener('keyup', handleKeyUp);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [handleKeyUp, handleClickOutside]);
    const hasDrawer = Boolean(drawer);
    const panelClasses = [
        'qmb-ui-brushaway',
        isOpen ? 'qmb-ui-brushaway--active' : '',
        hasDrawer ? 'qmb-ui-brushaway--with-drawer' : '',
        hasDrawer && drawerPosition === 'right' ? 'qmb-ui-brushaway--drawer-right' : '',
        className
    ]
        .filter(Boolean)
        .join(' ');
    return (React.createElement(React.Fragment, null,
        anchor && anchor({ onClick: toggleBrushaway }),
        ReactDOM.createPortal(React.createElement("div", { className: panelClasses, style: { display: isOpen ? 'flex' : 'none' }, role: "dialog", "aria-modal": "true", "aria-labelledby": "qmb-ui-brushaway-title", ref: brushawayRef, "data-allow-click": true },
            hasDrawer && React.createElement("aside", { className: "qmb-ui-brushaway__drawer" }, drawer),
            React.createElement("div", { className: "qmb-ui-brushaway__main", style: { minWidth: `${panelWidth}px`, maxWidth: `${panelWidth}px` } }, children)), document.body)));
}
/**
 * Brushaway component with built-in provider.
 * Use this as the main entry point - no need to wrap with BrushawayProvider.
 */
export function Brushaway({ controlledOpen, onClose, anchor, children, minWidth, closeOnClickOutside, drawer, drawerPosition, className }) {
    return (React.createElement(BrushawayProvider, { controlledOpen: controlledOpen, onClose: onClose },
        React.createElement(BrushawayInternal, { anchor: anchor, minWidth: minWidth, closeOnClickOutside: closeOnClickOutside, drawer: drawer, drawerPosition: drawerPosition, className: className }, children)));
}
